import { FC } from 'react';
// components
import { FormattedMessage } from 'dibs-react-intl';
import { LocalizedUnavailableIcon } from 'dibs-elements/exports/LocalizedUnavailableIcon';
import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense';

// styles
import styles from './PdpSharedAuctionUnavailable.scss';

export const PdpSharedAuctionUnavailable: FC = () => {
    return (
        <div className={styles.container}>
            <span className={styles.closed} data-tn="pdp-bidding-closed">
                <FormattedMessage
                    id="PdpSharedAuctionUnavailable.biddingClosed"
                    defaultMessage="Bidding Closed"
                />
            </span>
            <span className={styles.unavailable}>
                <ClientSuspense fallback={<div className={styles.icon} />}>
                    <LocalizedUnavailableIcon className={styles.icon} />
                </ClientSuspense>
            </span>
        </div>
    );
};
